import styled from "styled-components";

export const WrapperGraphics = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0px 20px 20px 20px;

    .section-bar {
      height: 400px;
      .section-data{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: -20vh;
        .section-title {
          width: 200px;
          background-color: aliceblue;
          color: black;
          border-radius: 10px;
          padding: 20px;
          margin: 10px;
          text-align: center;
          h2 {
            font-size: 14px;
            font-weight: bold;
          }
        }
        strong {
          font-weight: bold;
          font-size: 18px;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .section-button{
      display: flex;
      margin: 10px;
      margin-top: 40px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
`

export const WrapperService = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding:  0px 20px 20px 20px;
  margin: 0px 20px 20px 20px;
  border-radius: 10px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  border-color: #64748b;
  h3 {
    font-size: 18px;
    font-weight: bold;
  }

  .section-by-total {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .section-title {
    margin: 10px;
  }

  .section-chart {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2 columnas de igual tamaño */
    gap: 2rem;
    text-align: center;

    h2 {
      font-size: 14px;
      padding-bottom: 5px;
      border-bottom: 1px solid;
    }
  }
`;